import theme, { Colors } from '@qnpm/q-theme';
const { scenes: { baseColor } } = Colors;
const { font, layout } = theme;
const { emptyStatus: emptyStatusLayout } = layout;
class Style {
    constructor(isScale, size) {
        this.getStyle = () => {
            const { imgHeight, imgWidth, maxWidth } = this.layoutSize;
            // 容器基本样式
            const baseWrapperStyle = {
                justifyContent: 'center',
                alignItems: 'center'
            };
            const baseTitleStyle = {
                color: baseColor.text1
            };
            const baseTextStyle = {
                color: baseColor.text3,
                textAlign: 'center'
            };
            const normalStyle = {
                containerStyle: baseWrapperStyle,
                imageStyle: {
                    width: imgWidth.large,
                    height: imgHeight.large,
                    marginBottom: 12
                },
                titleConStyle: {
                    maxWidth: maxWidth.large,
                    marginBottom: 4
                },
                titleTextStyle: Object.assign(Object.assign({}, baseTitleStyle), { fontSize: this.fontSize.fontSizeL }),
                textContentStyle: {
                    maxWidth: maxWidth.large
                },
                textStyle: Object.assign(Object.assign({}, baseTextStyle), { fontSize: this.fontSize.fontSizeM, lineHeight: this.lineHeight.lineHeightT14 })
            };
            const smallStyle = {
                containerStyle: baseWrapperStyle,
                imageStyle: {
                    width: imgWidth.medium,
                    height: imgHeight.medium,
                    marginBottom: 12
                },
                titleConStyle: {
                    marginTop: 12,
                    maxWidth: maxWidth.medium,
                    marginBottom: 4
                },
                titleTextStyle: Object.assign(Object.assign({}, baseTitleStyle), { fontSize: this.fontSize.fontSizeS }),
                textContentStyle: {
                    maxWidth: maxWidth.medium
                },
                textStyle: Object.assign(Object.assign({}, baseTextStyle), { fontSize: this.fontSize.fontSizeXS, lineHeight: this.lineHeight.lineHeightT10 })
            };
            return this.size === 'small' ? smallStyle : normalStyle;
        };
        this.isScale = !!isScale;
        this.size = size;
        this.fontSize = isScale ? font.size.scaled : font.size.unscaled;
        this.lineHeight = isScale
            ? font.lineHeight.scaled
            : font.lineHeight.unscaled;
        this.layoutSize = isScale
            ? emptyStatusLayout.scaled
            : emptyStatusLayout.unscaled;
    }
}
export default Style;
